import ApiService from "@services/api.service";
import { Notify } from "quasar";
export const evaluationEntreprise = {
  state: {
    evaluations: [],
  },
  mutations: {
    setEvaluationsEntreprise(state, evaluations){
      state.evaluations = evaluations;
    },
  },
  actions:{
    async fetchEvaluationEntrepriseEtudiant(context, etudiant){
      try{
        const response = await ApiService.getRequest(`evaluation_entreprise/${etudiant}`);
        context.commit('setEvaluationsEntreprise', response.data);
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
      }
    }
  },
  getters:{
    getEvaluationsEntreprise(state){
      return state.evaluations;
    }
  }

}
